import React, { useState } from 'react';
import classnames from 'classnames';
import { parse } from 'node-html-parser';
import { useInView } from 'react-intersection-observer';

async function loadPolyfills() {
  if (typeof window.IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
}

loadPolyfills();

export function WPImage({ data, ...rest }) {
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '200px 0px 200px 0px',
    threshold: 0,
  });
  const { rendered } = data;
  const [message, setMessage] = useState('');

  const prepare = rendered.trim();

  const parsed = parse(prepare);

  const last = parsed.lastChild;

  const { tagName: Tag, classNames = [], firstChild } = last;
  const { tagName: ImageTag, classNames: imageClassNames = [], attributes } = firstChild;
  const { alt, src } = attributes;

  const figureClasses = classnames(...classNames);
  const imageClasses = classnames(...imageClassNames);

  return (
    <Tag ref={ref} className={figureClasses}>
      <ImageTag alt={alt} src={inView && src} className={imageClasses} />
    </Tag>
  );
}
